import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormlyFieldSelectProps, FormlySelectModule } from '@ngx-formly/core/select';
import { PickListComponent } from '../../components/pick-list/pick-list.component';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';

interface PickListProps extends FieldWrapperProps, FormlyFieldSelectProps {
  virtualScroll?: boolean;
  virtualScrollSize?: number;

  dragdrop?: boolean;
  showTargetFilter?: boolean;
  showTargetControls?: boolean;
  showSourceFilter?: boolean;
  showSourceControls?: boolean;

  optionLabel?: string;
  optionValue?: string;

  scrollHeight?: string;
}

export interface PickListFieldConfig extends FormlyFieldConfig<PickListProps> {
  type?: 'pick-list' | Type<PickListTypeComponent>;
}

@Component({
  selector: 'lib-formly-pick-list-type',
  templateUrl: './pick-list-type.component.html',
  styleUrl: './pick-list-type.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    NgClass,
    AsyncPipe,
    FormlySelectModule,
    PickListComponent
  ]
})
export class PickListTypeComponent extends FieldType<FieldTypeConfig<PickListProps>> {}
